import { useEffect, useRef } from 'react'

import { Action, type History } from 'history'
import { useHistory } from 'react-router-dom'

function useScrollMemory() {
  // react-router-dom's v5 types don't resolve under tsgolint, so `useHistory()`
  // comes back as an error type. Assert the `history` package's own type.
  const history = useHistory() as History
  const prevPath = useRef<string | undefined>(undefined)
  useEffect(() => {
    if (
      history.action !== Action.Pop &&
      history.location.pathname !== prevPath.current
    ) {
      window.scrollTo(0, 0)
    }
    prevPath.current = history.location.pathname
  }, [history.action, history.location.pathname])
}

function ScrollMemory() {
  useScrollMemory()
  return null
}

export default ScrollMemory
